import { useMutation } from '@tanstack/react-query';

import type {
  CloseShiftResponse,
  OpenShiftResponse,
  ServiceReceiptResponse,
  SetCashierResponse,
  SwitchModeResponse,
  SwitchVatModeResponse,
  XReportResponse,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useSetCashierMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; cashierId: string | number }) =>
      HttpClient.request<SetCashierResponse>({
        method: 'POST',
        url: params.url,
        data: { cashier_id: params.cashierId },
      }),
  });

export const useCreateServiceReceiptMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; value: string }) =>
      HttpClient.request<ServiceReceiptResponse>({
        method: 'POST',
        url: params.url,
        data: { value: params.value },
      }),
  });

export const useGenerateXReportMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<XReportResponse>({
        method: 'POST',
        url,
      }),
  });

export const useOpenShiftMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<OpenShiftResponse>({
        method: 'POST',
        url,
      }),
  });

export const useCloseShiftMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<CloseShiftResponse>({
        method: 'POST',
        url,
      }),
  });

export const useSwitchFiscalModeMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<SwitchModeResponse>({
        method: 'POST',
        url,
      }),
  });

export const useSwitchVatModeMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<SwitchVatModeResponse>({
        method: 'POST',
        url,
      }),
  });
